import styled from 'styled-components'

import { LocationType } from 'mobx/Localization/types'
import { getTranslatedTextByKey } from 'utils/language'
import LocationTypeButton from './LocationTypeButton'

export const LocationTypesContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 0.75rem;
    justify-content: center;
    flex-wrap: wrap;
`

interface LocationTypesProps {
    type?: LocationType
    onClickingType: (type: LocationType) => void
}

const LocationTypes = ({
    type,
    onClickingType,
}: LocationTypesProps) => (
        <LocationTypesContainer>
                <LocationTypeButton
                    onClick={() => onClickingType(LocationType.Appartment)}
                    selected={type === LocationType.Appartment}
                    iconUrl="/icons/homeLabel.svg"
                    text={getTranslatedTextByKey('webviewFlow.localization.appartmentLabel', 'Appartment')}
                />
                <LocationTypeButton
                    onClick={() => onClickingType(LocationType.Office)}
                    selected={type === LocationType.Office}
                    iconUrl="/icons/workLabel.svg"
                    text={getTranslatedTextByKey('webviewFlow.localization.workLabel', 'Work')}
                />
                <LocationTypeButton
                    onClick={() => onClickingType(LocationType.House)}
                    selected={type === LocationType.House}
                    iconUrl="/icons/homeLabel.svg"
                    text={getTranslatedTextByKey('webviewFlow.localization.homeLabel', 'Home')}
                />
                <LocationTypeButton
                    onClick={() => onClickingType(LocationType.Other)}
                    selected={type === LocationType.Other}
                    iconUrl="/icons/otherLabel.svg"
                    text={getTranslatedTextByKey('webviewFlow.localization.otherLabel', 'Other')}
                />
            </LocationTypesContainer>
    )

export default LocationTypes
